export const subCommunities = [
  // India
  {
    id: "68ac0531e4b95d75985eecf5",
    path: '/community/in/operations',
    title: 'Operations & Supply Chain - India',
    subtitle: 'Discuss, share, and grow in the world of operations and supply chain management.'
  },
  {
    id: "68ac0540e4b95d75985eecf7",
    path: '/community/in/program',
    title: 'Program & Project Management - India',
    subtitle: 'Collaborate, learn, and share experiences in program and project management.'
  },
  {
    id: "68ac0550e4b95d75985eecf9",
    path: '/community/in/product',
    title: 'Product Management - India',
    subtitle: 'Insights, discussions, and networking for product managers.'
  },
  {
    id: "68ac055ee4b95d75985eecfb",
    path: '/community/in/marketing',
    title: 'Marketing Management - India',
    subtitle: 'Strategies, trends, and discussions for marketing professionals.'
  },
  {
    id: "68ac056be4b95d75985eecfd",
    path: '/community/in/account',
    title: 'Sales and Account Management - India',
    subtitle: 'Techniques, networking, and advice for sales and account managers.'
  },
  {
    id: "68ac0576e4b95d75985eecff",
    path: '/community/in/category',
    title: 'Category and Vendor Management - India',
    subtitle: 'Best practices, strategies, and discussions for category and vendor managers.'
  },
  {
    id: "68ac0584e4b95d75985eed01",
    path: '/community/in/finance',
    title: 'Finance - India',
    subtitle: 'Finance insights, trends, and professional discussions.'
  },
  {
    id: "68ac058ee4b95d75985eed03",
    path: '/community/in/hr',
    title: 'Human Resources - India',
    subtitle: 'HR trends, recruitment strategies, and workplace management.'
  },
  {
    id: "68ac059de4b95d75985eed05",
    path: '/community/in/analyst',
    title: 'Analytics - India',
    subtitle: 'Data analytics discussions, tools, and insights.'
  },
  {
    id: "68ac05a9e4b95d75985eed07",
    path: '/community/in/strategy',
    title: 'Strategy and Consulting - India',
    subtitle: 'Business strategies, consulting insights, and industry best practices.'
  },
  {
    id: "68ac05b4e4b95d75985eed09",
    path: '/community/in/freshers',
    title: 'Freshers - India',
    subtitle: 'Building skills, sharing jobs, creating futures.'
  },

  // United States
  {
    id: "68ac05bee4b95d75985eed0b",
    path: '/community/us/operations',
    title: 'Operations & Supply Chain - US',
    subtitle: 'Discuss, share, and grow in the world of operations and supply chain management.'
  },
  {
    id: "68ac05d5e4b95d75985eed0d",
    path: '/community/us/program',
    title: 'Program & Project Management - US',
    subtitle: 'Collaborate, learn, and share experiences in program and project management.'
  },
  {
    id: "68ac05e0e4b95d75985eed0f",
    path: '/community/us/product',
    title: 'Product Management - US',
    subtitle: 'Insights, discussions, and networking for product managers.'
  },
  {
    id: "68ac05e9e4b95d75985eed11",
    path: '/community/us/marketing',
    title: 'Marketing Management - US',
    subtitle: 'Strategies, trends, and discussions for marketing professionals.'
  },
  {
    id: "68ac05f2e4b95d75985eed13",
    path: '/community/us/account',
    title: 'Sales and Account Management - US',
    subtitle: 'Techniques, networking, and advice for sales and account managers.'
  },
  {
    id: "68ac05fde4b95d75985eed15",
    path: '/community/us/category',
    title: 'Category and Vendor Management - US',
    subtitle: 'Best practices, strategies, and discussions for category and vendor managers.'
  },
  {
    id: "68ac0607e4b95d75985eed17",
    path: '/community/us/finance',
    title: 'Finance - US',
    subtitle: 'Finance insights, trends, and professional discussions.'
  },
  {
    id: "68ac0614e4b95d75985eed19",
    path: '/community/us/hr',
    title: 'Human Resources - US',
    subtitle: 'HR trends, recruitment strategies, and workplace management.'
  },
  {
    id: "68ac0620e4b95d75985eed1b",
    path: '/community/us/analyst',
    title: 'Analytics - US',
    subtitle: 'Data analytics discussions, tools, and insights.'
  },
  {
    id: "68ac0629e4b95d75985eed1d",
    path: '/community/us/strategy',
    title: 'Strategy and Consulting - US',
    subtitle: 'Business strategies, consulting insights, and industry best practices.'
  },

  // Global
  {
    id: "68ac0495e4b95d75985eecf3",
    path: '/community/introductions',
    title: 'Introductions and Discussions',
    subtitle: 'New members, introduce yourself and connect with everyone in the community.'
  },
  {
    id: "68ac064ee4b95d75985eed21",
    path: '/community/ask-the-community',
    title: 'Ask the Community',
    subtitle: 'Post questions, seek advice, and get answers from the community.'
  },
  {
    id: "68ac0657e4b95d75985eed23",
    path: '/community/announcements',
    title: 'Announcements',
    subtitle: 'Stay updated with the latest news and important updates.'
  },
  {
    id: "68ac0663e4b95d75985eed25",
    path: '/community/club-guidelines',
    title: 'Club Guidelines',
    subtitle: 'Read the community rules, standards, and participation guidelines.'
  }
];
